// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Atom_Box from "../atom/Atom_Box.bs.js";
import * as Atom_Cta from "../atom/Atom_Cta.bs.js";
import * as Atom_Grid from "../atom/Atom_Grid.bs.js";
import * as Atom_Label from "../atom/Atom_Label.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Util_Array from "../../util/Util_Array.bs.js";
import * as Atom_Column from "../atom/Atom_Column.bs.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Type_String from "../../type/Type_String.bs.js";
import * as Zone_Layout from "../../zone/Zone_Layout.bs.js";
import * as Template_Label from "./template/Template_Label.bs.js";
import * as Template_Player from "./template/Template_Player.bs.js";
import * as Layout_Constants from "./Layout_Constants.bs.js";
import * as Template_PlayNext from "./template/Template_PlayNext.bs.js";
import * as Type_Page_Program from "../../type/Type_Page_Program.bs.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../particle/Particle_Spacer_Ds.bs.js";
import * as Organism_Slider_Teaser from "../organism/slider/teaser/Organism_Slider_Teaser.bs.js";
import * as Particle_Screen_Constants from "../particle/Particle_Screen_Constants.bs.js";
import * as Particle_Spacer_Constants from "../particle/Particle_Spacer_Constants.bs.js";
import * as Organism_Video_Content_Presse from "../organism/slider/Organism_Video_Content_Presse.bs.js";
import * as Template_ProgramContent_Metas from "./template/program/Template_ProgramContent_Metas.bs.js";
import * as Template_ProgramContent_Description from "./template/program/Template_ProgramContent_Description.bs.js";

function getBlockSpace(mobileOpt, desktopOpt, param) {
  var mobile = mobileOpt !== undefined ? Caml_option.valFromOption(mobileOpt) : Particle_Spacer_Constants.Zone.mobile;
  var desktop = desktopOpt !== undefined ? Caml_option.valFromOption(desktopOpt) : Particle_Spacer_Constants.Zone.desktop;
  return Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(desktop), undefined, undefined, mobile);
}

var defaultBlockSpace = getBlockSpace(undefined, undefined, undefined);

var blockSpace = getBlockSpace(Caml_option.some(Particle_Spacer_Constants.ProgramPage.PlayNext.mobile), Caml_option.some(Particle_Spacer_Constants.ProgramPage.PlayNext.desktop), undefined);

function Layout_Program$TemplatePlayNext(Props) {
  var zone = Props.zone;
  var playedProgramId = Props.playedProgramId;
  var onPlayNextChange = Props.onPlayNextChange;
  var isPlayNextActivated = Props.isPlayNextActivated;
  if (zone === undefined) {
    return null;
  }
  var tmp = {
    blockSpace: blockSpace,
    zone: zone,
    onPlayNextChange: onPlayNextChange,
    isPlayNextActivated: isPlayNextActivated
  };
  if (playedProgramId !== undefined) {
    tmp.playedProgramId = Caml_option.valFromOption(playedProgramId);
  }
  return React.createElement(Template_PlayNext.make, tmp);
}

var TemplatePlayNext = {
  blockSpace: blockSpace,
  make: Layout_Program$TemplatePlayNext
};

var blockSpace$1 = getBlockSpace(Caml_option.some(Particle_Spacer_Constants.ProgramPage.Label.mobile), Caml_option.some(Particle_Spacer_Constants.ProgramPage.Label.desktop), undefined);

function Layout_Program$TemplateLabel(Props) {
  var zone = Props.zone;
  if (zone !== undefined) {
    return React.createElement(Template_Label.make, {
                blockSpace: blockSpace$1,
                zone: zone.VAL
              });
  } else {
    return null;
  }
}

var TemplateLabel = {
  blockSpace: blockSpace$1,
  make: Layout_Program$TemplateLabel
};

function Layout_Program$TemplatePartner(Props) {
  var partnerZone = Props.partnerZone;
  if (partnerZone !== undefined) {
    return React.createElement(Organism_Slider_Teaser.make, {
                blockSpace: defaultBlockSpace,
                zone: partnerZone.VAL
              });
  } else {
    return null;
  }
}

var TemplatePartner = {
  make: Layout_Program$TemplatePartner
};

var blockSpaceProgramContent = getBlockSpace(Caml_option.some(Particle_Spacer_Constants.ProgramPage.ProgramContent.mobile), Caml_option.some(Particle_Spacer_Constants.ProgramPage.ProgramContent.desktop), undefined);

function Layout_Program$TemplateProgramContentDescription(Props) {
  var program = Props.program;
  var descriptionBehavior = Props.descriptionBehavior;
  if (program !== undefined) {
    return React.createElement(Template_ProgramContent_Description.make, {
                teaser: program,
                descriptionBehavior: descriptionBehavior
              });
  } else {
    return null;
  }
}

var TemplateProgramContentDescription = {
  make: Layout_Program$TemplateProgramContentDescription
};

function Layout_Program$TemplateProgramContentMetas(Props) {
  var program = Props.program;
  var meta = Props.meta;
  var parent = Props.parent;
  var programContentButtons = Props.programContentButtons;
  if (meta === undefined) {
    return null;
  }
  if (program === undefined) {
    return null;
  }
  var tmp = {
    teaser: program,
    meta: meta,
    buttons: programContentButtons
  };
  if (parent !== undefined) {
    tmp.parent = Caml_option.valFromOption(parent);
  }
  return React.createElement(Template_ProgramContent_Metas.make, tmp);
}

var TemplateProgramContentMetas = {
  make: Layout_Program$TemplateProgramContentMetas
};

function Layout_Program$TemplateOtherSliders(Props) {
  var zones = Props.zones;
  if (zones !== undefined) {
    return Util_Array.NonEmpty.toReactElement(Util_Array.NonEmpty.map(Caml_option.valFromOption(zones), (function (slider) {
                      return React.createElement(Organism_Slider_Teaser.make, {
                                  blockSpace: defaultBlockSpace,
                                  zone: slider.VAL
                                });
                    })));
  } else {
    return null;
  }
}

var TemplateOtherSliders = {
  make: Layout_Program$TemplateOtherSliders
};

var blockSpace$2 = Particle_Screen_Ds.make(undefined, undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeAll("XL")), undefined, Particle_Spacer_Ds.makeNone(undefined));

function Layout_Program$TemplateEvent(Props) {
  var zone = Props.zone;
  if (zone === undefined) {
    return null;
  }
  var variant = zone.NAME;
  if (variant === "EventZone") {
    var match = zone.VAL;
    return React.createElement(Zone_Layout.EventZone.make, {
                blockSpace: blockSpace$2,
                teaser: match[0],
                textPosition: match[1]
              });
  }
  if (variant === "EventZoneWithTrailer") {
    var match$1 = zone.VAL;
    return React.createElement(Zone_Layout.EventZone.make, {
                blockSpace: blockSpace$2,
                teaser: match$1[0],
                textPosition: match$1[1],
                programId: match$1[2]
              });
  }
  var match$2 = zone.VAL;
  return React.createElement(Zone_Layout.EventZone.make, {
              blockSpace: blockSpace$2,
              teaser: match$2[0],
              textPosition: match$2[1],
              clip: {
                TAG: /* Clip */0,
                _0: match$2[2]
              }
            });
}

var TemplateEvent = {
  blockSpace: blockSpace$2,
  make: Layout_Program$TemplateEvent
};

var rules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.margin("auto")]);

var blockSpace$3 = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeBottom("S"));

var boxDirection = Particle_Screen_Ds.make(undefined, undefined, undefined, "row", undefined, "column");

var gridRules = Particle_Screen_Ds.make(undefined, undefined, undefined, [
      CssJs.display("grid"),
      CssJs.gridTemplateColumns([{
              NAME: "repeat",
              VAL: [
                {
                  NAME: "num",
                  VAL: 3
                },
                CssJs.fr(1)
              ]
            }]),
      CssJs.gridTemplateAreas({
            NAME: "areas",
            VAL: {
              hd: "description description metas",
              tl: {
                hd: "description description metas",
                tl: /* [] */0
              }
            }
          })
    ], undefined, [
      CssJs.gridTemplateColumns([CssJs.fr(1)]),
      CssJs.gridAutoRows("auto"),
      CssJs.gridTemplateAreas({
            NAME: "areas",
            VAL: {
              hd: "description",
              tl: {
                hd: "metas",
                tl: /* [] */0
              }
            }
          })
    ]);

var gridDescriptionRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.gridArea({
            NAME: "ident",
            VAL: "description"
          })]);

var descriptionBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeRight("XL")), undefined, Particle_Spacer_Ds.makeNone(undefined));

var gridMetaRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.gridArea({
            NAME: "ident",
            VAL: "metas"
          })]);

var metaBlockSpace = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeTop("XL")), Caml_option.some(Particle_Spacer_Ds.makeTop("Zero")), undefined, Particle_Spacer_Ds.makeTop("M"));

function Layout_Program(Props) {
  var isPlayNextActivated = Props.isPlayNextActivated;
  var onPlayNextChange = Props.onPlayNextChange;
  var playedProgramId = Props.playedProgramId;
  var layout = Props.layout;
  var player = Props.player;
  var match = Type_Page_Program.programContent(layout);
  var match$1;
  if (match !== undefined) {
    var match$2 = match.VAL;
    match$1 = [
      match$2[0],
      match$2[1],
      match$2[2]
    ];
  } else {
    match$1 = [
      undefined,
      undefined,
      /* Auto */0
    ];
  }
  var program = match$1[0];
  var ctas = Type_Page_Program.ctas(layout);
  var ctaButtons = ctas !== undefined ? Belt_Array.map(Util_Array.NonEmpty.toArray(Caml_option.valFromOption(ctas)), (function (param) {
            var identifier = param.identifier;
            var kind = param.kind;
            var label = param.label;
            switch (kind.TAG | 0) {
              case /* Href */0 :
                  return Caml_option.some(React.createElement(Atom_Cta.Link.make, {
                                  href: Curry._1(Type_String.Href.toString, kind._0),
                                  identifier: identifier,
                                  label: label,
                                  style: kind._1
                                }));
              case /* Button */1 :
                  var onClick = kind._0;
                  return Caml_option.some(React.createElement(Atom_Cta.Button.make, {
                                  identifier: identifier,
                                  label: label,
                                  onClick: (function (param) {
                                      Curry._1(onClick, undefined);
                                    }),
                                  style: kind._1
                                }));
              case /* Info */2 :
                  return Caml_option.some(React.createElement(Atom_Label.make, {
                                  text: label,
                                  style: kind._0
                                }));
              
            }
          })) : [];
  var programContentButtons = Util_Array.catOption(ctaButtons);
  var download = Type_Page_Program.download(layout);
  var tmp = {
    zone: Type_Page_Program.playNext(layout),
    onPlayNextChange: onPlayNextChange,
    isPlayNextActivated: isPlayNextActivated
  };
  if (playedProgramId !== undefined) {
    tmp.playedProgramId = Caml_option.valFromOption(playedProgramId);
  }
  var tmp$1 = {
    program: program,
    meta: Type_Page_Program.meta(layout),
    programContentButtons: programContentButtons
  };
  var tmp$2 = match$1[1];
  if (tmp$2 !== undefined) {
    tmp$1.parent = Caml_option.valFromOption(tmp$2);
  }
  return React.createElement(Atom_Column.make, {
              alignItems: Particle_Screen_Constants.alignItemsCenter,
              blockSpace: blockSpace$3,
              children: null,
              kind: /* Main */6,
              maxWidth: Layout_Constants.maxWidthMainContentScreen,
              rules: rules,
              width: Particle_Screen_Constants.oneHundredPctWidth
            }, React.createElement(Template_Player.make, {
                  player: player
                }), React.createElement(Layout_Program$TemplateEvent, {
                  zone: Type_Page_Program.$$event(layout)
                }), React.createElement(Layout_Program$TemplatePlayNext, tmp), React.createElement(Atom_Box.make, {
                  children: React.createElement(Atom_Grid.make, {
                        children: null,
                        rules: gridRules
                      }, React.createElement(Atom_Column.make, {
                            blockSpace: descriptionBlockSpace,
                            children: null,
                            rules: gridDescriptionRules,
                            width: Particle_Screen_Constants.oneHundredPctWidth
                          }, React.createElement(Layout_Program$TemplateProgramContentDescription, {
                                program: program,
                                descriptionBehavior: match$1[2]
                              }), React.createElement(Layout_Program$TemplateLabel, {
                                zone: Type_Page_Program.label(layout)
                              })), React.createElement(Atom_Column.make, {
                            blockSpace: metaBlockSpace,
                            children: React.createElement(Layout_Program$TemplateProgramContentMetas, tmp$1),
                            rules: gridMetaRules,
                            width: Particle_Screen_Constants.oneHundredPctWidth
                          })),
                  direction: boxDirection,
                  spacer: blockSpaceProgramContent,
                  width: Particle_Screen_Constants.oneHundredPctWidth
                }), React.createElement(Layout_Program$TemplatePartner, {
                  partnerZone: Type_Page_Program.partner(layout)
                }), React.createElement(Layout_Program$TemplateOtherSliders, {
                  zones: Type_Page_Program.sliders(layout)
                }), download !== undefined ? React.createElement(Atom_Box.make, {
                    children: React.createElement(Organism_Video_Content_Presse.make, {
                          title: download.title,
                          id: download.id,
                          items: {
                            TAG: /* Download */0,
                            _0: download.items
                          },
                          href: download.href
                        }),
                    direction: boxDirection,
                    spacer: blockSpaceProgramContent,
                    width: Particle_Screen_Constants.oneHundredPctWidth
                  }) : null);
}

var make = Layout_Program;

export {
  getBlockSpace ,
  defaultBlockSpace ,
  TemplatePlayNext ,
  TemplateLabel ,
  TemplatePartner ,
  blockSpaceProgramContent ,
  TemplateProgramContentDescription ,
  TemplateProgramContentMetas ,
  TemplateOtherSliders ,
  TemplateEvent ,
  rules ,
  blockSpace$3 as blockSpace,
  boxDirection ,
  gridRules ,
  gridDescriptionRules ,
  descriptionBlockSpace ,
  gridMetaRules ,
  metaBlockSpace ,
  make ,
}
/* defaultBlockSpace Not a pure module */
